import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetSubDealersQueryParams {
  subDealerIds?: number[];
  dealerUsernames?: string[];
  enabled?: boolean | undefined;
}

export const getSubDealers = async (
  props: QueryProps<GetSubDealersQueryParams>
): Promise<NewUser[]> => {
  const res = await api.client.get("/sub-dealers-new", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
